export const ButtonIds = {
  save: 'button_save_config'
};

export const LinksOrActions = {
  devDocs: 'control.goToDevDocs',
  communitySupport: 'control.goToCommunitySupport',
  learnMore: 'valueprop.learnMore',
  publishAll: 'control.publish',
  reset: 'control.reset'
};

export const MessagingContent = {
  controlPanelHeader: 'control.header',
  controlPanelSubheader: 'control.subtitle',
  darkMode: 'control.dark',
  header: 'header',
  needMoreHelp: 'control.needMoreHelp',
  preview: 'control.preview',
  valueProp: 'valueprop.content',
  valuePropSource: 'valueprop.source',
  previewRelevantOffers: 'preview.relevantOffer',
  placementLegacyConfigWarning: 'warning.placementLegacyConfig'
};

export const ConfigMessages = {
  color: {
    black: 'control.bannerColor.black',
    blue: 'control.bannerColor.blue',
    white: 'control.bannerColor.white',
    whiteNoBorder: 'control.bannerColor.whiteNoBorder'
  },
  logoPosition: {
    left: 'control.logoPosition.left',
    right: 'control.logoPosition.primary',
    top: 'control.logoPosition.top'
  },
  logoType: {
    alternative: 'control.logoType.alternative',
    inline: 'control.logoType.inLine',
    none: 'control.logoType.none',
    primary: 'control.logoType.primary'
  },
  ratio: {
    '8x1': 'control.bannerRatio.8x1',
    '20x1': 'control.bannerRatio.20x1'
  },
  textColor: {
    black: 'control.textColor.black',
    grayscale: 'control.textColor.grayscale',
    monochrome: 'control.textColor.monochrome',
    white: 'control.textColor.white'
  },
  textSize: {
    small: 'control.textSize.small',
    medium: 'control.textSize.medium',
    large: 'control.textSize.large'
  }
};

export const MessagingPlacementMessages = {
  cart: 'control.placement.cart',
  cart_preview: 'control.placement.cartPreview',
  category: 'control.placement.categoryPage',
  checkout: 'control.placement.checkout',
  home: 'control.placement.home',
  homepage: 'control.placement.homepage',
  mini_cart: 'control.placement.miniCart',
  product: 'control.placement.productPage',
  product_preview: 'control.placement.productPreview',
  shop: 'control.placement.shop'
};

export const PageNames = {
  product: 'product',
  cart: 'cart',
  checkout: 'checkout',
  homepage: 'home',
  category: 'category'
};

// This is a mapping that upstream team has, which fit the “product families”
// short-term is for all the pay in 3/4 products
// long-term is for monthly installments like US Pay Monthly and DE Ratenzahlung
// pay in 1 is for Pay in 30 days in germany
export const offerTypes = {
  PAY_LATER_SHORT_TERM: 'PAY_LATER_SHORT_TERM',
  PAY_LATER_LONG_TERM: 'PAY_LATER_LONG_TERM',
  PAYPAL_CREDIT_NO_INTEREST: 'PAYPAL_CREDIT_NO_INTEREST',
  PAY_LATER_PAY_IN_1: 'PAY_LATER_PAY_IN_1'
};

// map of supported offerType to productPrice
export const productPriceMap = {
  US: {
    PAY_LATER_SHORT_TERM: '88.44',
    PAY_LATER_LONG_TERM: '200.82',
    PAY_LATER_GENERIC: ''
  },
  FR: {
    PAY_LATER_SHORT_TERM: '88.44'
  },
  GB: {
    PAY_LATER_SHORT_TERM: '88.44'
  },
  AU: {
    PAY_LATER_SHORT_TERM: '88.44'
  },
  DE: {
    PAY_LATER_PAY_IN_1: '100.00',
    PAY_LATER_LONG_TERM: '100.00'
  },
  ES: {
    PAY_LATER_SHORT_TERM: '50'
  },
  IT: {
    PAY_LATER_SHORT_TERM: '50'
  }
};

export const SelectionLabels = {
  color: 'control.label.bannerBackgroundColor',
  logoPosition: 'control.label.logoPosition',
  logoType: 'control.label.logoType',
  ratio: 'control.label.bannerRatio',
  textColor: 'control.label.textColor',
  textSize: 'control.label.textSize'
};
